import { render, staticRenderFns } from "./GatewaySoftwareLog.vue?vue&type=template&id=1cffb01c&scoped=true&"
import script from "./GatewaySoftwareLog.vue?vue&type=script&lang=ts&"
export * from "./GatewaySoftwareLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffb01c",
  null
  
)

export default component.exports